<template>
  <div class="property-input-component">
    <Skeleton v-if="!loaded" height="48px" v-bind:loading="true" style="display: block;"></Skeleton>

    <a-collapse v-if="hasProperty && loaded" v-model="activeKey">
      <a-collapse-panel v-bind:header="property.formatted_address">
        <span v-if="($mq !== 'mobile' && $mq !== 'tablet')" slot="extra" style="display:inline-block;margin:-5px;">
          <a-button v-on:click="handleEditClick" v-if="!onlyDeleteButton">
            Pand bewerken
          </a-button>
          <a-button v-on:click="handleEnrichClick" v-bind:loading="loadingEnrichment" v-if="!onlyDeleteButton">
            Gegevens verrijken
          </a-button>
          <a-button type="danger" v-on:click="handleDeleteClick">
            Adres wijzigen
          </a-button>
        </span>

        <span v-else slot="extra" style="display:inline-block;margin:-5px;">
          <a-button v-on:click="handleEditClick" v-if="!onlyDeleteButton" title="Pand bewerken">
            <pencil-icon></pencil-icon>
          </a-button>
          <a-button v-on:click="handleEnrichClick" v-bind:loading="loadingEnrichment" v-if="!onlyDeleteButton" title="Gegevens verrijken">
            <plus-icon></plus-icon>
          </a-button>
          <a-button type="danger" v-on:click="handleDeleteClick" title="Adres wijzigen">
            <delete-icon></delete-icon>
          </a-button>
        </span>

        <PropertyShowComponent
            v-bind:key="propertyShowKey"
            v-bind:property-object="property"
            v-bind:edit="false"
            v-on:property-updated="handlePropertyUpdated"
            v-on:updated="onPropertyUpdated"/>
      </a-collapse-panel>
    </a-collapse>

    <a-alert
        v-if="!hasProperty && loaded && noPropertyMessageDisplay"
        :message="(customerFullName || 'Deze klant') + ' heeft nog geen bezoekadres, voeg eerst een adres toe'"
        type="warning"
        show-icon
    />

    <a-button v-if="!hasProperty && loaded"
              v-bind:id="'add_' + addressType + '_property_button'"
              class="create-button"
              type="primary"
              v-on:click="handleShowPropertyCreate">
      <div v-if="customButtonName">
        {{ customButtonName }}
      </div>
      <div v-else>Adres toevoegen</div>
    </a-button>

    <a-modal v-bind:id="'search_' + addressType + '_property_modal'"
             v-on:cancel="handleCancelPropertySelect"
             v-on:ok="handlePropertySelected"
             title="Adres toevoegen"
             v-model="createModalVisible" width="700"
             class="property-input-component-modal">
      <div v-if="customerId">
        <h4>Klantadressen</h4>
        <div v-if="customerAssociatedProperties">
          <a-select style="width: 100%" @change="onCustomerAssociatedPropertySelected">
            <a-select-option v-for="(option, key) in customerAssociatedProperties" :key="key">
              {{ option.formatted_address }}
            </a-select-option>
          </a-select>
        </div>
        <div v-else>Er zijn nog geen adressen aan deze klant gekoppeld</div>
        <h4 style="margin-top: 2rem">Adres zoeken</h4>
      </div>
      <PropertySearchOrCreateByAddressComponent v-bind:include="['valuations']" style="margin-bottom: 15px;"
                                                v-on:property-selected="onPropertySelected"/>
      <div v-if="hasSelectedProperty">
        <p><b>Geselecteerde pand</b></p>
        {{ selectedProperty.description }}
      </div>
    </a-modal>

    <input :name="inputName" :value="propertyId" type="hidden"/>

    <PropertyEditDrawerComponent ref="editDrawer" v-if="hasProperty" v-bind:property="property"
                                 v-on:updated="handlePropertyUpdated"/>
  </div>
</template>

<script>
import PropertyEditDrawerComponent from './EditDrawerComponent'
import PropertyShowComponent from '~/modules/property/components/ShowComponent'
import PropertySearchByAddressComponent from '~/modules/property/components/SearchByAddressComponent'
import propertyApi from "~/api/property"
import {Skeleton} from 'vue-loading-skeleton';
import PropertySearchOrCreateByAddressComponent from "./SearchOrCreateByAddressComponent";

export default {
  name: "PropertyInputComponent",
  components: {
    PropertyEditDrawerComponent,
    PropertySearchOrCreateByAddressComponent,
    PropertyShowComponent,
    PropertySearchByAddressComponent,
    Skeleton
  },
  props: {
    propertyProp: {
      type: Object,
      required: false,
      default: null
    },
    inputName: {
      type: String,
      required: false,
      default: 'property_id'
    },
    defaultPropertyId: {
      type: [String, Number],
      default: null
    },
    addressType: {
      default: null,
      required: false
    },
    emitEvents: {
      type: Boolean,
      required: false,
      default: false
    },
    customButtonName: {
      type: String,
      required: false,
      default: null
    },
    onlyDeleteButton: {
      type: Boolean,
      required: false,
      default: false
    },
    customerId: {
      type: [Number, String],
      required: false,
      default: null,
    },
    customerFullName: {
      type: String,
      required: false,
      default: null
    },
    noPropertyMessageDisplay: {
      type: Boolean,
      required: false,
      default: true
    }
  },
  data() {
    return {
      loaded: false,
      loadingEnrichment: false,
      propertyShowKey: 1,
      property: null,
      createModalVisible: false,
      selectedProperty: null,
      activeKey: ['1'],
      customerAssociatedProperties: null
    };
  },
  mounted() {
    if (this.defaultPropertyId !== null && this.defaultPropertyId !== '') {
      propertyApi.findById(this.defaultPropertyId, ['valuations']).then((response) => {
        this.property = response.data;
        this.loaded = true;
      });
    } else {
      this.loaded = true;
    }
    if (this.customerId !== null) {
      propertyApi.getPropertiesAssociatedWithCustomer(this.customerId).then(response => {
        this.customerAssociatedProperties = response.data
      })
    }
  },
  computed: {
    hasProperty() {
      return this.property !== null;
    },
    hasSelectedProperty() {
      return this.selectedProperty !== null;
    },
    propertyId() {
      if (this.property !== null) {
        return this.property.id;
      }
      return null;
    }
  },
  methods: {
    handleDeleteClick() {
      event.stopPropagation();

      this.$confirm({
        title: 'Pand ontkoppelen',
        content: 'Weet je zeker dat je dit pand wil ontkoppelen?',
        okText: 'Ja',
        cancelText: 'Annuleren',
        onOk: () => {
          this.property = null;
          if (this.emitEvents) {
            this.$emit('property-deleted')
          }
        },
        onCancel() {
        },
      });
    },
    handleEditClick() {
      event.stopPropagation();
      this.$refs.editDrawer.visible = true;
    },
    handleEnrichClick() {
      event.stopPropagation();
      this.updatePropertyWithJumba();
    },
    handleShowPropertyCreate() {
      this.property = null;
      this.createModalVisible = true;
    },
    onPropertySelected(property) {
      this.selectedProperty = property;
    },
    onPropertyUpdated(property) {
      this.property = property;
    },
    handlePropertySelected() {
      if (!this.hasSelectedProperty) {
        this.$message.warning('Selecteer eerst een pand');
      } else {
        this.property = this.selectedProperty;
        this.propertyShowKey++;
        this.createModalVisible = false;

        if (this.emitEvents) {
          this.$emit('property-selected', this.selectedProperty)
        }
      }
    },
    handleCancelPropertySelect() {
      this.createModalVisible = false;
    },
    handlePropertyUpdated(property) {
      this.property = property;
      this.$emit('property-updated', property)
    },
    updatePropertyWithJumba() {
      if (this.property !== null) {
        this.loadingEnrichment = true;
        this.$emit('loading-enrichment', true)

        propertyApi.updateWithJumba(this.property)
            .then(response => {
              this.property = response.data;
              this.propertyShowKey++;
              this.$emit('property-updated', this.property)
            })
            .finally(() => {
              this.loadingEnrichment = false;
              this.$emit('loading-enrichment', false)
            })
      }
    },
    onCustomerAssociatedPropertySelected(key) {
      this.selectedProperty = this.customerAssociatedProperties[key];
    }
  }
}
</script>

<style scoped>
.edit-mortgage-properties {
  position: relative;
  margin-bottom: 15px;
}

.create-button {
  margin-top: 15px;
}
</style>
